import React, { useContext, useRef, useState, useEffect } from 'react';
import { ThemeContext } from '../../store/ThemeProvider';
import './Type2.scss';
import { IViewDetail } from '../../global.d';
import Type3 from './Type3';
import intl from 'react-intl-universal';
import { getGalleryStatus } from '../../utils/util';
import { IGalleryType, IGalleryData, IGalleryList } from './GalleryType';
import { inject, observer } from 'mobx-react';
import Lock from './Lock';
import uImageCount from './useImageCount';
import {renderGalleryName} from './AllForGallery';
import { resolveLocaleText } from '../../utils/localeText';
// 这是原来的Type3

const Type2 = (props: IGalleryType) => {
  const {
    image,
    link,
    gallerys = {} as IGalleryList,
    info = true,
    total = true,
    showname = true,
    namealign = 'left',
    imageadjust = false,
    desc,
  } = props; 

  const { h1Color } = useContext(ThemeContext);
  const loc = intl.getInitOptions().currentLocale;
  const displayName = resolveLocaleText(
    link ? link.desc : desc,
    (link && link.desc_i18n) || props.desc_i18n,
    loc
  );

  const { view_detail, image_total, gallery } =
    ['subgallery', 'gallery'].indexOf(link.type) > -1
      ? uImageCount(link, gallerys)
      : {
          view_detail: null,
          image_total: 0,
          gallery: {
            name: desc,
            status: ''
          }
        };

  const typeRef = useRef<any>(null);

  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (typeRef && typeRef.current) {
      setWidth(Math.floor(typeRef.current.clientWidth - 10));
      setHeight((Math.floor(typeRef.current.clientWidth - 10) * 2) / 3);
    }
  }, [typeRef]);
  
  return (
    <div className="type2-outer" ref={typeRef}>
      <Type3
        {...props}
        className={'type2-wrapper'}
        style={width && height ? { width, height } : null}
        imageStyle={!!imageadjust ? "wx_gallery_a_2" : "wx_gallery_mode_2"}
      />
      {showname ? <div
        className={'type2-name ' + namealign}
        style={{ /*width: width,*/ color: h1Color }}
      >
        {renderGalleryName((gallery || {})!.name, displayName)}
      </div> : null}
    </div>
  );
};

export default Type2;
